import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import isEmpty from 'lodash/isEmpty';

import { Text } from '@nerdwallet/currency';
import {
  getIssuerName,
  getLearnMoreLink,
} from '@nerdwallet/marketplace/selectors/common';

import BankReviewLink from './bank-review-link';
import BulletedList from '../bulleted-list/bulleted-list';
import Row from '../row/row';
import VerticalSpacer from '../vertical-spacer/vertical-spacer';

const DetailsSection = ({ data }) => {
  const marketingBullets = get(data, 'details.account_details.value', []);
  const name = getIssuerName(data);
  const siteLink = getLearnMoreLink(data);

  return (
    <Row className="table__details-section">
      <Row className="table__details-section__content">
        <Row className="table__details-section__content__left">
          <Text className="table__details-section__content__header" bold>
            Details
          </Text>
          <VerticalSpacer mobile="p-18" tablet="p-8" desktop="p-8" />
          {!isEmpty(marketingBullets) ? (
            <Fragment>
              <BulletedList bullets={marketingBullets} />
              <VerticalSpacer mobile="p-18" tablet="p-8" desktop="p-8" />
            </Fragment>
          ) : null}
          <BankReviewLink
            issuer={name}
            siteLink={siteLink}
            className="table__details-section__content__link"
          />
        </Row>
        <VerticalSpacer mobile="p-40" />
      </Row>
    </Row>
  );
};

DetailsSection.propTypes = {
  data: PropTypes.shape({
    details: PropTypes.shape({
      account_details: PropTypes.shape({
        value: PropTypes.string,
      }),
      display_name: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
    product: PropTypes.shape({
      institution: PropTypes.shape({
        details: PropTypes.shape({
          display_name: PropTypes.shape({
            value: PropTypes.string,
          }),
          nw_review_url: PropTypes.shape({
            value: PropTypes.string,
          }),
        }),
      }),
    }),
  }),
};

DetailsSection.defaultProps = {
  data: {},
};

DetailsSection.displayName = 'DetailsSection';

export default DetailsSection;
